import PropTypes from 'prop-types';
import React from 'react';

const ModalWrapper = ({
    modalHeader,
    children,
    message,
    icon,
    isPortal,
    withOverlay,
    className,
    isShown,
}) =>
    isShown && (
        <>
            <div className={`custom-modal ${className}`}>
                {icon && <div className="modal-icon">{icon}</div>}
                {message && <p className="modal-message">{message}</p>}
                <div className="modal-content-wrapper">
                    <header className="modal-header">{modalHeader}</header>
                    <div className="modal-content">{children}</div>
                </div>
            </div>
            {withOverlay && <div className={`overlay ${isPortal ? 'fixed' : ''}`} />}
        </>
    );

ModalWrapper.defaultProps = {
    isShown: false,
    className: '',
    modalHeader: null,
    message: null,
    children: null,
    icon: null,
    withOverlay: true,
    isPortal: true,
};

ModalWrapper.propTypes = {
    isShown: PropTypes.bool,
    className: PropTypes.string,
    modalHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.object,
    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    withOverlay: PropTypes.bool,
    isPortal: PropTypes.bool,
};

export default ModalWrapper;
